import { isValidProductKind, productKindLabel } from './productKinds';

export function ProductKindBadge({ kind }: { kind?: string }) {
  if (!isValidProductKind(kind)) return null;
  return (
    <span className="vendor-console__badge vendor-console__badge--active vendor-product-kind-badge">
      {productKindLabel(kind)}
    </span>
  );
}
